import {
    Box,
    FormControl,
    Grid2,
    IconButton,
    Input,
    InputAdornment,
    Tab,
} from "@mui/material";
import React, { useState, useCallback } from "react";

import { TabContext, TabList, TabPanel } from "@mui/lab";
import HealthDataHistory from "../HealthDataHistory/HealthDataHistory";
import PatientInfo from "../PatientInfo/PatientInfo";
import ProgressOverview from "../ProgressOverview/ProgressOverview";
import SaveIcon from "@mui/icons-material/Save";
import {
    HEALTH_STARTING_TYPE,
    HEALTH_TYPE,
    HEALTH_UNIT,
    PERMISSIONS,
} from "../../helper/constant";
import { hasAccess, httpRequest, onRequestError } from "../../helper/global";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
    setPatientData,
    setPatientHealthData,
} from "../../reducers/patientSlice";
import { showAlert } from "../../reducers/alertSlice";
import { AIHealthInsightCard } from "../AIHealthInsightCard/AIHealthInsightCard";
import { CoachDiscussion } from "../CoachDiscussion/CoachDiscussion";
import EducationalMaterials from "../EducationalMaterials/EducationalMaterials";

export default function PatientTab({
    theme,
    user,
    permissionConfig,
    patient,
    startDate,
    endDate,
    handleOnStartDateChange,
    handleOnEndDateChange,
    healthData,
    weightDateRange,
    handleWeightDateRangeChange,
}) {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [value, setValue] = React.useState("overview");
    const [selectedRange, setSelectedRange] = useState(14);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    const handleOnSave = useCallback(
        async (type, value) => {
            let key = "";
            const postData = {};

            switch (type) {
                case HEALTH_TYPE.BODY_MASS:
                    key = `${HEALTH_STARTING_TYPE.startingWeight}`;
                    dispatch(setPatientHealthData({ [key]: value }));
                    key = `healthData.${HEALTH_STARTING_TYPE.startingWeight}`;
                    postData[`${key}`] = value;

                    //compute for BMI
                    if (
                        !patient ||
                        !patient.healthData ||
                        !patient.healthData.height ||
                        patient.healthData.healthData === 0
                    ) {
                        dispatch(
                            showAlert({
                                title: "",
                                message: `Please set the patient's height to auto compute "Starting BMI".`,
                            }),
                        );
                    } else {
                        // const bmi = computeBMI(
                        //     value,
                        //     patient.healthData.height
                        // );
                        // key = `${HEALTH_STARTING_TYPE.startingBMI}`;
                        // dispatch(setPatientHealthData({ [key]: bmi }));
                        // key = `healthData.${HEALTH_STARTING_TYPE.startingBMI}`;
                        // postData[`${key}`] = bmi;
                    }

                    {
                        const startingBodyFatPercentage =
                            patient.healthData.startingBodyFatPercentage || 0;

                        const newStartingLeanBodyMass =
                            value * (1 - startingBodyFatPercentage / 100);

                        key = `${HEALTH_STARTING_TYPE.startingLeanBodyMass}`;
                        dispatch(
                            setPatientHealthData({
                                [key]: newStartingLeanBodyMass,
                            }),
                        );
                        key = `healthData.${HEALTH_STARTING_TYPE.startingLeanBodyMass}`;
                        postData[`${key}`] = parseFloat(
                            newStartingLeanBodyMass.toFixed(2),
                        );
                    }

                    break;

                case HEALTH_STARTING_TYPE.startingWeightDate:
                    key = `${HEALTH_STARTING_TYPE.startingWeightDate}`;
                    dispatch(setPatientHealthData({ [key]: value }));
                    key = `healthData.${HEALTH_STARTING_TYPE.startingWeightDate}`;
                    postData[`${key}`] = value;
                    break;

                case HEALTH_TYPE.BODY_FAT_PERCENTAGE:
                    key = `${HEALTH_STARTING_TYPE.startingBodyFatPercentage}`;
                    dispatch(setPatientHealthData({ [key]: value * 1 }));
                    key = `healthData.${HEALTH_STARTING_TYPE.startingBodyFatPercentage}`;
                    postData[`${key}`] = value;

                    {
                        const newStartingLeanBodyMass =
                            patient.healthData.startingWeight *
                            (1 - value / 100);

                        key = `${HEALTH_STARTING_TYPE.startingLeanBodyMass}`;
                        dispatch(
                            setPatientHealthData({
                                [key]: newStartingLeanBodyMass,
                            }),
                        );

                        key = `healthData.${HEALTH_STARTING_TYPE.startingLeanBodyMass}`;
                        postData[`${key}`] = parseFloat(
                            newStartingLeanBodyMass.toFixed(2),
                        );
                    }
                    break;

                case HEALTH_TYPE.LEAN_BODY_MASS:
                    key = `${HEALTH_STARTING_TYPE.startingLeanBodyMass}`;
                    dispatch(setPatientHealthData({ [key]: value * 1 }));
                    key = `healthData.${HEALTH_STARTING_TYPE.startingLeanBodyMass}`;
                    postData[`${key}`] = value;
                    break;

                case HEALTH_STARTING_TYPE.treatmentStartDate:
                    key = `${HEALTH_STARTING_TYPE.treatmentStartDate}`;
                    dispatch(setPatientHealthData({ [key]: value }));
                    key = `healthData.${HEALTH_STARTING_TYPE.treatmentStartDate}`;
                    postData[`${key}`] = value;
                    break;

                case HEALTH_TYPE.HEIGHT:
                    key = `${HEALTH_TYPE.HEIGHT}`;
                    dispatch(setPatientHealthData({ [key]: value * 1 }));
                    key = `healthData.${HEALTH_TYPE.HEIGHT}`;
                    postData[`${key}`] = value;
                    break;

                case "dob":
                    key = `dob`;
                    dispatch(setPatientData({ [key]: value }));
                    postData[`${key}`] = value;
                    break;

                case "gender":
                    key = type;
                    dispatch(setPatientData({ [key]: value }));
                    postData[`${key}`] = value;
                    break;

                case "firstName":
                    key = `${type}`;
                    dispatch(setPatientData({ [key]: value }));
                    postData[`${key}`] = value;
                    break;

                case "lastName":
                    key = `${type}`;
                    dispatch(setPatientData({ [key]: value }));
                    postData[`${key}`] = value;
                    break;
            }

            try {
                const result = await httpRequest(
                    `patient/update/${patient.id}`,
                    postData,
                    "POST",
                    (error) => {
                        onRequestError(dispatch, navigate, {
                            title: error.title,
                            message: error.message,
                        });
                    },
                );

                if (result === false) {
                    return;
                }
            } catch (error) {
                console.error("Error fetching data:", error);
            }
        },
        [patient],
    );

    const buildInputForm = useCallback(
        (
            ref,
            inputType,
            type = "",
            defaultValue = "",
            status,
            onChange,
            onSave,
        ) => {
            const sx = isNaN(defaultValue) ? {} : { width: "150px" };

            return (
                <FormControl sx={sx} variant="standard">
                    <Input
                        disabled={
                            !hasAccess(
                                user,
                                permissionConfig,
                                "patient",
                                PERMISSIONS.write,
                            )
                        }
                        inputRef={ref}
                        type={inputType}
                        value={defaultValue}
                        sx={{ pl: 1 }}
                        inputProps={{ min: 0 }}
                        onChange={onChange}
                        endAdornment={
                            <InputAdornment position="end">
                                {HEALTH_UNIT[type]}
                                {hasAccess(
                                    user,
                                    permissionConfig,
                                    "patient",
                                    PERMISSIONS.write,
                                ) && (
                                    <IconButton
                                        aria-label="Set Starting Weight"
                                        onClick={() => {
                                            if (!ref || !ref.current) {
                                                return;
                                            }

                                            handleOnSave(
                                                type,
                                                ref.current.value,
                                            );

                                            if (!onSave) {
                                                return;
                                            }

                                            onSave();
                                        }}
                                    >
                                        <SaveIcon
                                            sx={{
                                                color: !status
                                                    ? theme.palette.color.icon
                                                    : "red",
                                            }}
                                        />
                                    </IconButton>
                                )}
                            </InputAdornment>
                        }
                    />
                </FormControl>
            );
        },
        [user, permissionConfig],
    );

    const buildOverview = useCallback(
        (type = "header") => {
            if (type === "header") {
                return <Tab label="Overview" value="overview" />;
            }

            return (
                <TabPanel value="overview" sx={{ p: { xs: 1, md: 2 } }}>
                    <Grid2
                        container
                        spacing={{ xs: 2, md: 2 }}
                        display={"flex"}
                    >
                        <Grid2 size={{ xs: 12, md: 4 }}>
                            {patient && (
                                <PatientInfo
                                    theme={theme}
                                    user={user}
                                    permissionConfig={permissionConfig}
                                    patient={patient}
                                    buildInputForm={buildInputForm}
                                    handleOnSave={handleOnSave}
                                />
                            )}
                        </Grid2>
                        <Grid2 size={{ xs: 12, md: 8 }}>
                            {patient && (
                                <ProgressOverview
                                    theme={theme}
                                    dispatch={dispatch}
                                    navigate={navigate}
                                    user={user}
                                    permissionConfig={permissionConfig}
                                    patient={patient}
                                    buildInputForm={buildInputForm}
                                    handleOnSave={handleOnSave}
                                    weightDateRange={weightDateRange}
                                    handleWeightDateRangeChange={
                                        handleWeightDateRangeChange
                                    }
                                />
                            )}
                        </Grid2>
                    </Grid2>
                </TabPanel>
            );
        },
        [user, patient, permissionConfig],
    );

    const buildWeight = useCallback(
        (type = "header") => {
            if (!user || !permissionConfig) {
                return;
            }

            if (
                !hasAccess(
                    user,
                    permissionConfig,
                    "healthData",
                    PERMISSIONS.read,
                )
            ) {
                return;
            }

            if (type === "header") {
                return <Tab label="Health Data" value="weight" />;
            }

            return (
                <TabPanel value="weight" sx={{ p: { xs: 1, md: 2 } }}>
                    <HealthDataHistory
                        theme={theme}
                        user={user}
                        permissionConfig={permissionConfig}
                        startDate={startDate}
                        endDate={endDate}
                        handleOnStartDateChange={handleOnStartDateChange}
                        handleOnEndDateChange={handleOnEndDateChange}
                        selectedRange={selectedRange}
                        setSelectedRange={setSelectedRange}
                        healthData={healthData}
                        patient={patient}
                        dispatch={dispatch}
                        navigate={navigate}
                    />
                </TabPanel>
            );
        },
        [user, permissionConfig, healthData],
    );

    const buildAIInsight = useCallback(
        (type = "header") => {
            if (!user || !permissionConfig) {
                return;
            }

            if (
                !hasAccess(
                    user,
                    permissionConfig,
                    "healthData",
                    PERMISSIONS.read,
                )
            ) {
                return;
            }

            if (type === "header") {
                return <Tab label="AI Insight" value="aiInsight" />;
            }

            return (
                <TabPanel value="aiInsight" sx={{ p: { xs: 1, md: 2 } }}>
                    <AIHealthInsightCard
                        dispatch={dispatch}
                        navigate={navigate}
                        theme={theme}
                        user={user}
                        permissionConfig={permissionConfig}
                        patient={patient}
                    />
                </TabPanel>
            );
        },
        [user, permissionConfig, healthData],
    );

    const buildCoachDiscussion = useCallback(
        (type = "header") => {
            if (!user || !permissionConfig) {
                return;
            }

            if (
                !hasAccess(
                    user,
                    permissionConfig,
                    "healthData",
                    PERMISSIONS.read,
                )
            ) {
                return;
            }

            if (type === "header") {
                return <Tab label="Coach Discussion" value="coachDiscussion" />;
            }

            return (
                <TabPanel value="coachDiscussion" sx={{ p: { xs: 1, md: 2 } }}>
                    <CoachDiscussion
                        dispatch={dispatch}
                        navigate={navigate}
                        theme={theme}
                        user={user}
                        permissionConfig={permissionConfig}
                        patient={patient}
                    />
                </TabPanel>
            );
        },
        [user, permissionConfig, healthData],
    );

    const buildEducationalMaterials = useCallback(
        (type = "header") => {
            if (!user || !permissionConfig) {
                return;
            }

            if (
                !hasAccess(
                    user,
                    permissionConfig,
                    "healthData",
                    PERMISSIONS.read,
                )
            ) {
                return;
            }

            if (type === "header") {
                return (
                    <Tab
                        label="Educational Materials"
                        value="educationalMaterials"
                    />
                );
            }

            return (
                <TabPanel
                    value="educationalMaterials"
                    sx={{ p: { xs: 1, md: 2 } }}
                >
                    <EducationalMaterials
                        theme={theme}
                        user={user}
                        permissionConfig={permissionConfig}
                        syncEducationalMaterials={false}
                    />
                </TabPanel>
            );
        },
        [user, permissionConfig, healthData],
    );

    if (!permissionConfig) {
        return;
    }

    return (
        <>
            <TabContext value={value}>
                <Box
                    sx={{
                        borderBottom: 1,
                        borderColor: "divider",
                        position: "sticky",
                        top: 128,
                        backgroundColor: "background.default",
                        zIndex: 9,
                        pb: 0,
                    }}
                >
                    <TabList
                        onChange={handleChange}
                        aria-label="Patient Tabs"
                        sx={{
                            "& .MuiTab-root": {},
                            "& .MuiTab-root.Mui-selected": {
                                color: theme.palette.tabSelected.main,
                            },
                            "& .MuiTabs-indicator": {
                                backgroundColor: theme.palette.tabSelected.main,
                            },
                        }}
                    >
                        {buildOverview()}
                        {buildWeight()}
                        {hasAccess(
                            user,
                            permissionConfig,
                            "ai",
                            PERMISSIONS.read,
                        ) && buildAIInsight()}

                        {hasAccess(
                            user,
                            permissionConfig,
                            "ai",
                            PERMISSIONS.read,
                        ) && buildCoachDiscussion()}
                        {buildEducationalMaterials()}
                    </TabList>
                </Box>
                {buildOverview("content")}
                {buildWeight("content")}
                {hasAccess(user, permissionConfig, "ai", PERMISSIONS.read) &&
                    buildAIInsight("content")}
                {hasAccess(user, permissionConfig, "ai", PERMISSIONS.read) &&
                    buildCoachDiscussion("content")}
                {buildEducationalMaterials("content")}
            </TabContext>
        </>
    );
}
